/** Map UI / Opp labels to trading-engine `ExchangeId` JSON names. */

const LABEL_MAP: Record<string, string> = {
  OKX: 'OKX',
  BYBIT: 'Bybit',
  BINANCE: 'Binance',
  BINANCEPERP: 'Binance',
  BINANCEUSDMSWAP: 'Binance',
  GATEIO: 'Gateio',
  GATE: 'Gateio',
  BITGET: 'Bitget',
  ASTER: 'Aster',
  EDGEX: 'EdgeX',
  EDGE: 'EdgeX',
  EDGE_X: 'EdgeX',
  HYPERLIQUID: 'Hyperliquid',
  LIGHTER: 'Lighter',
  PARADEX: 'Paradex',
};

export function labelToManualTradingExchange(label: string): string | null {
  const normalized = label.trim().toUpperCase().replace(/[\s-]+/g, '');
  return LABEL_MAP[normalized] ?? null;
}

export function arbDirectionJson(
  direction: 'long1_short2' | 'short1_long2'
): 'LongAshortB' | 'LongBshortA' {
  return direction === 'long1_short2' ? 'LongAshortB' : 'LongBshortA';
}
